import { Box, Divider, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import parse from "html-react-parser";

function Notification({ notification, onClick }) {
    return (
        <Box
            sx={{
                width: 280,
                backgroundColor: notification.read ? "#fafafa" : "#fff3e8",
                ":hover": { backgroundColor: notification.read ? "#f4f5f8" : "#ffe8d6" },
                transitionDuration: "0.2s",
                cursor: "pointer",
                borderRadius: 1,
                border: notification.read ? "1px solid rgba(19, 33, 68, 0.08)" : "1px solid rgba(209, 81, 45, 0.35)",
            }}
            onClick={onClick}
        >
            <Box sx={{ p: 2 }}>
                <Typography sx={{ fontSize: 12, textAlign: "right" }} color="text.secondary">
                    {moment(notification.datetime).format("DD/MM/YYYY HH:mm")}
                </Typography>
                <Typography sx={{ mt: 1, fontWeight: "bold" }}>
                    {notification.title}
                </Typography>
                <Typography className='ellipsis-text' sx={{ mt: 1, fontWeight: "light", maxHeight: 60 }}>
                    {parse(notification.message, { htmlparser2: { decodeEntities: false } })}
                </Typography>
            </Box>

            <Divider sx={{ mt: 1.5 }} />
        </Box>
    )
}

export default Notification